import type { IconProps } from './IconProps';

type ChevronSelectorIconProps = IconProps & {
  upClass?: string;
  downClass?: string;
};

export const ChevronSelectorIcon = ({ upClass, downClass, ...props }: ChevronSelectorIconProps) => (
  <svg
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 12}
    height={props.height ?? 12}
    {...props}
  >
    <path
      d="M7.87955 5.02205H4.12032C3.79106 5.02205 3.62617 4.60066 3.85899 4.35421L5.7386 2.36458C5.88293 2.21181 6.11694 2.21181 6.26127 2.36458L8.14089 4.35421C8.37371 4.60066 8.20881 5.02205 7.87955 5.02205Z"
      fill="currentColor"
      className={upClass}
    />
    <path
      d="M7.87955 6.97815H4.12032C3.79106 6.97815 3.62617 7.39954 3.85899 7.64599L5.7386 9.63562C5.88293 9.7884 6.11694 9.7884 6.26127 9.63562L8.14089 7.64599C8.37371 7.39954 8.20881 6.97815 7.87955 6.97815Z"
      fill="currentColor"
      className={downClass}
    />
  </svg>
);
